<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Max Square",
        para: "This project has been designed while working at Cobold. All the copyrights to this project belong to Cobold. Showcasing my UI design contribution for this project.",
        company: "Max Estates",
        year: "2021",
        project: "UI/UX",
        coverimg: "/img/gallery/ui/max/cover.jpg",
        TwoImgleft: "/img/gallery/ui/max/twoleft.svg",
        TwoImgRight: "/img/gallery/ui/max/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/max/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/max/threeright.svg",
        coverimg2: "/img/gallery/ui/max/cover2.jpg",
      },
    };
  },
};
</script>
